export default __webpack_public_path__ + "static/media/logo.70b915c2.png";